"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calls = {};

var cache = function () {
	var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(func, key, value) {
		var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;
		var hash, result;
		return _regenerator2.default.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						hash = "key:" + key + "_value:" + value; // this can be pretty simple for our use case

						if (!(calls[hash] !== undefined)) {
							_context.next = 3;
							break;
						}

						return _context.abrupt("return", calls[hash].result);

					case 3:
						_context.next = 5;
						return func(value);

					case 5:
						result = _context.sent;


						calls[hash] = {
							result: result,
							expire: setTimeout(function () {
								delete calls[hash];
							}, duration)
						};

						return _context.abrupt("return", result);

					case 8:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function cache(_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	};
}();

var _default = cache;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(calls, "calls", "src/utilities/cache.js");

	__REACT_HOT_LOADER__.register(cache, "cache", "src/utilities/cache.js");

	__REACT_HOT_LOADER__.register(_default, "default", "src/utilities/cache.js");
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/utilities/cache.js